import { InjectionToken, inject } from '@angular/core';

// DeviceStore의 reload 함수 타입
export type DeviceReloadFn = () => void;

// 앱에서 DeviceReloadFn을 제공하기 위한 InjectionToken
export const DEVICE_RELOAD_FN = new InjectionToken<DeviceReloadFn>('DEVICE_RELOAD_FN');

// 빈 함수로 기본 처리
export function injectDeviceReloadFn(): DeviceReloadFn {
  return inject(DEVICE_RELOAD_FN, { optional: true }) || (() => {});
}
